import React, { useState } from "react";
import SearchSelect from "components/ui/SearchSelect";
import AudienceSelect from "components/products/AudienceSelect";
import { useGetOrganizationsQuery } from "apis/organization";
import { useGetOrganizationOfficesQuery } from "apis/packageRule";

// Organization only narrows the office list — offices are what gets stored.
const ProviderAvailability = ({ value, onChange, error }) => {
  const [organizationId, setOrganizationId] = useState("");
  const { data: organizations = [] } = useGetOrganizationsQuery();
  const { data: organizationOffices = [] } =
    useGetOrganizationOfficesQuery(organizationId);

  const organizationOptions = organizations.map((organization) => ({
    value: organization._id,
    label: organization.name,
  }));

  return (
    <div className="space-y-2">
      <label className="form-label">Organization</label>
      <SearchSelect
        options={organizationOptions}
        value={
          organizationOptions.find(
            (option) => option.value === organizationId
          ) || null
        }
        onChange={(option) => setOrganizationId(option?.value || "")}
        placeholder="All organizations"
        isClearable
      />

      <label className="form-label">Availability</label>
      <AudienceSelect
        value={value}
        onChange={onChange}
        error={error}
        offices={organizationId ? organizationOffices : undefined}
      />
    </div>
  );
};

export default ProviderAvailability;
